import { CLEAR_STATUS } from '@store/action-types/menu';

const clearStatus = () => ({ type: CLEAR_STATUS });

export default clearStatus;
